import { render, staticRenderFns } from "./BSFieldWrapper.vue?vue&type=template&id=0d67a2fc&scoped=true&"
import script from "./BSFieldWrapper.vue?vue&type=script&lang=js&"
export * from "./BSFieldWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BSFieldWrapper.vue?vue&type=style&index=0&id=0d67a2fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d67a2fc",
  null
  
)

export default component.exports